import './app/styles/index.css'
import { startApp } from './app/bootstrap/start-app'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('#root element is missing from index.html')
void startApp(rootElement)
